<template>
    <a-card>
        <span slot="title">
            <i class="fa fa-bar-chart"></i> Lifetime Totals
            <a slot="extra">
                <div v-if="loading">
                    <VclList :height="350" :width="600"></VclList>
                </div>
                <a-button v-else type="primary" icon="reload" class="pull-right" @click.preent="refresh">
                  Refresh
                </a-button>
            </a>
        </span>

        <div class="site-stats">
            <template v-if="!loading">
            <div class="content">
              <a-row :gutter="16">
                <a-col :span="8">
                  <a-card>
                    <a-statistic
                        title="Total Subscribers"
                        :value="numberWithCommas(lifetimeTotals.subscribers)"
                        :value-style="{ color: '#3f8600' }"
                        style="margin-right: 50px"
                    >
                    </a-statistic>
                  </a-card>
                </a-col>
                <a-col :span="8">
                  <a-card>
                    <a-statistic
                        title="Emails Sent"
                        :value="numberWithCommas(lifetimeTotals.emails_sent)"
                        class="demo-class"
                        :value-style="{ color: '#13cf8d' }"
                    >
                    </a-statistic>
                  </a-card>
                </a-col>
                <a-col :span="8">
                  <a-card>
                    <a-statistic
                        title="Unsubscribes"
                        :value="numberWithCommas(lifetimeTotals.unsubscribes)"
                        class="demo-class"
                        :value-style="{ color: '#cf1322' }"
                    >
                    </a-statistic>
                  </a-card>
                </a-col>
              </a-row>
              <a-row justify="center" :gutter="[16,100]">
                    <a-col :span="6">
                      <vc-donut
                          background="white" foreground="#e1e9f6"
                          :size="80" unit="px" :thickness="30"
                          has-legend legend-placement="bottom"
                          :sections="[{ label: 'Opens', value: toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.opens), color: '#3392ff' }]" :total="100"
                          :start-angle="0"
                      >
                        <h1>{{ toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.opens) }}%</h1>
                      </vc-donut>
                    </a-col>
                    <a-col :span="6">
                      <vc-donut
                          background="white" foreground="#e1f4f6"
                          :size="80" unit="px" :thickness="30"
                          has-legend legend-placement="bottom"
                          :sections="[{ label: 'Clicks', value: toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.clicks), color: '#47d170' }]" :total="100"
                          :start-angle="0"
                      >
                        <h1>{{ toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.clicks) }}%</h1>
                      </vc-donut>
                    </a-col>
                    <a-col :span="6">
                      <vc-donut
                          background="white" foreground="#f6eee3"
                          :size="80" unit="px" :thickness="30"
                          has-legend legend-placement="bottom"
                          :sections="[{ label: 'Unsubscribes', value: toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.unsubscribes), color: '#ff9b00' }]" :total="100"
                          :start-angle="0"
                      >
                        <h1>{{ toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.unsubscribes) }}%</h1>
                      </vc-donut>
                    </a-col>
                    <a-col :span="6">
                      <vc-donut
                          background="white" foreground="#f2ebeb"
                          :size="80" unit="px" :thickness="30"
                          has-legend legend-placement="bottom"
                          :sections="[{ label: 'Bounces', value: toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.bounces), color: '#ff4e4e' }]" :total="100"
                          :start-angle="0"
                      >
                        <h1>{{ toPercentage(lifetimeTotals.emails_sent, lifetimeTotals.bounces) }}%</h1>
                      </vc-donut>
                    </a-col>
                  </a-row>
            </div>
        </template>
        </div>
    </a-card>
</template>

<script>
  import Api from "@/services/Api.js";
  import { VclList } from 'vue-content-loading';

  export default {
      components: {VclList},
      data() {
        return {
            lifetimeTotals: [],
            loading: true
        };
    },

      methods: {
        loadData(type = '') {
            this.loading = true;
            const query = type !== '' ? '?refresh=true' : '';
            Api.get(`sites/${this.$route.params.siteId}/overview/lifetime-totals` + query).then((response) => {
                this.lifetimeTotals = response.data.lifetimeTotals;
                this.loading = false;
            });
        },

        refresh() {
            this.loadData('refresh');
        },

        toPercentage(total, amount) {
          if (total) {
            // eslint-disable-next-line no-magic-numbers
            const percent = (100 * amount) / total;

            if (percent) {
              // eslint-disable-next-line no-magic-numbers
              return Number(percent.toFixed(2));
            }
          }

          return 0;
        },

        numberWithCommas(value) {
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    },

      mounted() {
          this.loadData();
      }
};
</script>

<style lang="scss">
$border-color: #f6f6f6;

.site-stats {
    margin-bottom: 30px;
    background: #fff;

    .content {
        position: relative;

        .stats {
            display: flex;

            .section {
                width: 33.33%;
                height: 90px;
                padding-top: 16px;
                text-align: center;
                border: 1px solid $border-color;
                border-top: none;

                &:first-child {
                    border-right: none;
                    border-left: none;
                }

                &:last-child {
                    border-right: none;
                    border-left: none;
                }

                .title {
                    font-size: 1.2em;
                    color: #7f8c8d;
                }

                .qty {
                    margin-top: 12px;
                    font-size: 1.5em;
                    font-weight: 400;
                    color: #000;
                }
            }
        }

        .totals--dognut-charts {
            display: flex;
            justify-content: space-between;
            margin: 30px 30px 0;

            .cdc-legend-item-color {
                display: none;
            }

            .cdc-legend {
                margin-top: 5px;
            }

            .cdc-text h1 {
                font-size: 14px;
            }

            .row {
                width: 100%;

                .cdc-container {
                    margin-bottom: 30px;
                }
            }
        }

        .content--footer {
            display: flex;
            justify-content: space-between;
            padding: 30px 20px 20px;
            border-top: 1px solid $border-color;
        }

        @media screen and (max-width: 782px) {

            .content--footer {
                flex-direction: column;
                text-align: center;
            }

            .stats {

                .section {

                    .title {
                        font-size: 1em;
                    }

                    .qty {
                        font-size: 1.5em;
                    }
                }
            }
        }
    }
}
</style>
